import { type TransformedCollectOrder } from "~/api/collect/hooks/use-get-collect-order";
import { type CollectOrderLinesArgs } from "~/api/collect/request";

type ParseOrderLinesToCollectArgs = {
  orderLineToCollectIds: string[];
  activeOrderLines: TransformedCollectOrder["activeOrderLines"];
};

export const parseOrderLinesToCollect = ({
  orderLineToCollectIds,
  activeOrderLines
}: ParseOrderLinesToCollectArgs): CollectOrderLinesArgs["orderLines"] => {
  return orderLineToCollectIds.reduce<CollectOrderLinesArgs["orderLines"]>(
    (acc, id) => {
      const line = activeOrderLines.find((l) => l.id === id);
      if (line?.productLineId) {
        acc.push({
          productLineId: line.productLineId,
          orderId: line.orderId
        });
      }
      return acc;
    },
    []
  );
};
